import highlightText from "utils/highlightText";

export const renderDeletionMessage = (organizationName: string) =>
  highlightText({
    baseStyle: { whiteSpace: "pre-wrap" },
    highlightStyle: { fontWeight: "bold", fontStyle: "italic" },
  })`Are you sure you want to delete group ${organizationName} ?\nThis can not be undone.`;
